import { NivelAcesso, SubNivelAcesso } from '../services/api/users/UserServices';

export function filtrarMenuPorPermissao(
    menuConfig: NivelAcesso,
    permissoesUsuario: NivelAcesso
): NivelAcesso {
    const menuFiltrado: NivelAcesso = {};

    for (const nomeMenu in menuConfig) {
        if (Object.prototype.hasOwnProperty.call(menuConfig, nomeMenu)) {
            const subItensDoMenu = menuConfig[nomeMenu as keyof NivelAcesso] as SubNivelAcesso;

            const permissoesDoMenuPrincipal = permissoesUsuario[nomeMenu as keyof NivelAcesso];

            if (!permissoesDoMenuPrincipal) {
                continue; 
            }

            const subItensFiltrados: SubNivelAcesso = {};
            let possuiSubItemVisivel = false;

            for (const nomeSubItem in subItensDoMenu) {
                if (Object.prototype.hasOwnProperty.call(subItensDoMenu, nomeSubItem)) {
                    const permissaoDoSubItem = permissoesDoMenuPrincipal[nomeSubItem as keyof SubNivelAcesso];

                    if (typeof permissaoDoSubItem === 'string' && permissaoDoSubItem !== '') {
                        subItensFiltrados[nomeSubItem as keyof SubNivelAcesso] = permissaoDoSubItem;
                        possuiSubItemVisivel = true;
                    }
                }
            }

            if (possuiSubItemVisivel) {
                menuFiltrado[nomeMenu as keyof NivelAcesso] = subItensFiltrados;
            }
        }
    }

    return menuFiltrado;
}